import React, { useEffect, useState } from 'react'
import { Badge, Button } from 'antd'
import {
  BellOutlined,
  SoundOutlined,
  SoundFilled,
  UserOutlined,
  CreditCardOutlined,
  QuestionCircleOutlined,
  DollarCircleOutlined,
  ExportOutlined,
  BankOutlined,
  WalletOutlined
} from '@ant-design/icons'
import { COLORS } from 'app/constants'
import { useUserList } from 'app/hooks/trade/userList'
import { useUserSocket } from 'app/hooks/trade/userSocket'
import { useHistory } from 'react-router'
import { useTradeModalStore } from '../../../../hooks/trade/modalStore'
import { useNotification } from '../../../../hooks/useNotification'
import { goTo } from '../../../../hooks/navigation'
import { NotificationContainer, CompactButton } from './styles'
import SoundRepeat2 from '../../../SoundRepeat/SoundRepeat2'
import SoundRepeat3 from '../../../SoundRepeat/SoundRepeat3'
import SoundRepeat4 from '../../../SoundRepeat/SoundRepeat4'
import SoundRepeat5 from '../../../SoundRepeat/SoundRepeat5'
import SoundRepeat6 from '../../../SoundRepeat/SoundRepeat6'
import SoundRepeat7 from '../../../SoundRepeat/SoundRepeat7'

const NotificationBadges: React.FC = () => {
  const { data: res, playsound5 } = useNotification('/admin/overview2', false)
  const { data: res2 } = useNotification('/admin/overview', true)

  const data = res?.users
  const vaccount = res?.vaccount
  const cash = res2?.cash
  const pgPayment = res?.pgPayment
  const ticket = res2?.ticket

  const { data: modalStore, mutate: muateModalStore } = useTradeModalStore()
  const nav = useHistory()

  const socket = useUserSocket()
  const { userlist, sendwho } = useUserList()

  // 알림 상태 관리 (localStorage에 저장)
  const [notificationEnabled, setNotificationEnabled] = useState(() => {
    const saved = localStorage.getItem('admin-notification-enabled')
    return saved !== null ? JSON.parse(saved) : true
  })

  useEffect(() => {
    sendwho()
  }, [])

  useEffect(() => {
    localStorage.setItem('admin-notification-enabled', JSON.stringify(notificationEnabled))
  }, [notificationEnabled])

  const handleSoundToggle = () => {
    muateModalStore({ ...modalStore, sound: !modalStore?.sound })
  }

  const handleNotificationToggle = () => {
    setNotificationEnabled(!notificationEnabled)

    // 알림이 꺼질 때 기존 알림들도 모두 지우기
    if (notificationEnabled) {
      window?.document
        ?.querySelectorAll('.ant-notification-close-x')
        .forEach((i: any) => {
          i?.click()
        })
    }
  }

  return (
    <NotificationContainer>
      {/* 소리 토글 */}
      <CompactButton
        className={`icon-only ${modalStore?.sound ? 'active' : 'muted'}`}
        onClick={handleSoundToggle}
        title={modalStore?.sound ? '소리 ON (클릭하여 끄기)' : '소리 OFF (클릭하여 켜기)'}
        style={{
          background: modalStore?.sound
            ? 'rgba(24, 144, 255, 0.2)'
            : 'rgba(140, 140, 140, 0.2)',
          borderColor: modalStore?.sound
            ? 'rgba(24, 144, 255, 0.4)'
            : 'rgba(140, 140, 140, 0.4)',
          color: modalStore?.sound ? '#1890ff' : '#8c8c8c'
        }}
      >
        {modalStore?.sound ? (
          <SoundFilled className="compact-icon" />
        ) : (
          <SoundOutlined className="compact-icon" />
        )}
      </CompactButton>

      {/* 알림 토글 */}
      <CompactButton
        className={`icon-only ${notificationEnabled ? 'active' : 'muted'}`}
        onClick={handleNotificationToggle}
        title={notificationEnabled ? '알림 ON (클릭하여 끄기)' : '알림 OFF (클릭하여 켜기)'}
        style={{
          background: notificationEnabled
            ? 'rgba(24, 144, 255, 0.2)'
            : 'rgba(140, 140, 140, 0.2)',
          borderColor: notificationEnabled
            ? 'rgba(24, 144, 255, 0.4)'
            : 'rgba(140, 140, 140, 0.4)',
          color: notificationEnabled ? '#1890ff' : '#8c8c8c'
        }}
      >
        <BellOutlined className="compact-icon" />
      </CompactButton>

      {/* 접속자 수 */}
      <CompactButton
        className="green"
        onClick={() => goTo(nav, '/users/10')}
        title={`접속자: ${userlist?.length || 0}명`}
      >
        <UserOutlined className="compact-icon" />
        {userlist?.length || 0}
      </CompactButton>

      {/* 가상계좌 */}
      <Badge count={vaccount?.count} overflowCount={99} size="small">
        <CompactButton
          className={vaccount?.count > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/users/9')}
        >
          <CreditCardOutlined className="compact-icon" />
          가상계좌
        </CompactButton>
        {playsound5 && modalStore?.sound && <SoundRepeat5 />}
      </Badge>

      {/* 모투신청 */}
      <Badge count={data?.testUser} overflowCount={99} size="small">
        <CompactButton
          className={data?.testUser > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/users/4')}
        >
          <QuestionCircleOutlined className="compact-icon" />
          모투
        </CompactButton>
        {data?.testUser > 0 && modalStore?.sound && <SoundRepeat3 />}
      </Badge>

      {/* 가입요청 */}
      <Badge count={data?.joinUser} overflowCount={99} size="small">
        <CompactButton
          className={data?.joinUser > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/users/1')}
        >
          <UserOutlined className="compact-icon" />
          가입
        </CompactButton>
        {data?.joinUser > 0 && modalStore?.sound && <SoundRepeat6 />}
      </Badge>

      {/* 문의 */}
      <Badge count={ticket?.waitingCount} overflowCount={99} size="small">
        <CompactButton
          className={ticket?.waitingCount > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/ticket/0')}
        >
          <QuestionCircleOutlined className="compact-icon" />
          문의
        </CompactButton>
        {ticket?.waitingCount > 0 && modalStore?.sound && <SoundRepeat4 />}
      </Badge>

      {/* 입금 */}
      <Badge count={cash?.new1} overflowCount={99} size="small">
        <CompactButton
          className={cash?.new1 > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/cash/deposit?process=1')}
        >
          <DollarCircleOutlined className="compact-icon" />
          입금
        </CompactButton>
        {cash?.new1 > 0 && modalStore?.sound && <SoundRepeat2 />}
      </Badge>

      {/* 출금 */}
      <Badge count={cash?.new2} overflowCount={99} size="small">
        <CompactButton
          className={cash?.new2 > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/cash/withdrawal?process=1')}
        >
          <ExportOutlined className="compact-icon" />
          출금
        </CompactButton>
        {cash?.new2 > 0 && modalStore?.sound && <SoundRepeat7 />}
      </Badge>

      {/* PG입금 */}
      <Badge count={pgPayment?.pgNew1} overflowCount={99} size="small">
        <CompactButton
          className={pgPayment?.pgNew1 > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/cash/pg/deposit?process=1')}
        >
          <BankOutlined className="compact-icon" />
          PG입금
        </CompactButton>
        {pgPayment?.pgNew1 > 0 && modalStore?.sound && <SoundRepeat2 />}
      </Badge>

      {/* PG출금 */}
      <Badge count={pgPayment?.pgNew2} overflowCount={99} size="small">
        <CompactButton
          className={pgPayment?.pgNew2 > 0 ? 'active' : ''}
          onClick={() => goTo(nav, '/cash/pg/withdraw?process=1')}
        >
          <WalletOutlined className="compact-icon" />
          PG출금
        </CompactButton>
        {pgPayment?.pgNew2 > 0 && modalStore?.sound && <SoundRepeat7 />}
      </Badge>
    </NotificationContainer>
  )
}

export default React.memo(NotificationBadges)